import React from "react";
import Menu from "./Menu";
import Banner from "./Banner";
import Category from "./Category";
import "../../styles/Home.scss"


const Home: React.FC = () => {
  return (
    <div className="home">
      <Menu />
      <Banner />
      <Category />
    </div>
  );
};

export default Home;
